// The six fixed sections of the clinical draft (Phase 1 quotation G4), when the
// hospital switches them on (ai_settings.structured_clinical_draft). Mirrors
// backend/utils/clinicalDraftSections.js — change both together. Advisory:
// a missing section is pointed out, never blocks approval.
export const CLINICAL_DRAFT_SECTIONS = [
  'Chief Complaints', 'History', 'Examination', 'Assessment', 'Treatment Information', 'Clinical Summary',
] as const;

const norm = (s: string) => s.toLowerCase().replace(/[*_#:]/g, '').replace(/\s+/g, ' ').trim();

/** Which of the six headings the note does not contain as a heading line. */
export function missingSections(text: string): string[] {
  const lines = new Set(text.split('\n').map(norm).filter((l) => l && l.length <= 40));
  return CLINICAL_DRAFT_SECTIONS.filter((h) => !lines.has(norm(h)));
}
